import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'importer-app-turbine',
  templateUrl: './turbine.component.html',
  styleUrls: ['./turbine.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class TurbineComponent implements OnInit {
  @Input() speed = '';
  @Input() contrast = false;
  @Input() withPole = true;
  @Input() shadow = true;
  @Input() text = false;

  currLoadingNum = 0;
  reload = false;

  ngOnInit() {
    if (this.text) {
      this.updateLoadingNum();
    }
  }

  updateLoadingNum() {
    setTimeout(() => {
      if (this.currLoadingNum < 5) {
        this.reload = true;
        setTimeout(() => {
          this.currLoadingNum += 1;
          this.reload = false;
          this.updateLoadingNum();
        }, 350);
      }
    }, 4000);
  }
}
